module.exports = __webpack_public_path__ + "static/media/Staffing Order.2b9fab47.pdf";